// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1WD_M","right":"styles_right__2MMCH"};